export default __webpack_public_path__ + "static/media/sell (1).49711b70.png";